import React, { Dispatch, SetStateAction } from 'react';
import Card from '@mui/material/Card';
import { Autoclave, OpenAssignBoxModal, OpenSporetestModal, SporetestingResult } from '../types';
import { Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningAmber';
import theme from '../../../../themes/theme';
import UnassignedSporetestsWithBoxes from './UnassignedSporetestsWithBoxes';
import UnassignedSporetestsWithoutBoxes from './UnassignedSporetestsWithoutBoxes';
import { Biobox } from '../../../../types';

interface UnassignedSporetestsProps {
  autoclaves: Autoclave[];
  bioboxesById: Map<number, Biobox>,
  reload: () => Promise<void>;
  unassignedTestResults: SporetestingResult[];
  setOpenAssignBioboxModal: Dispatch<SetStateAction<OpenAssignBoxModal>>;
  setOpenSporetestModal: Dispatch<SetStateAction<OpenSporetestModal>>;
}

const UnassignedSporetests = (props: UnassignedSporetestsProps) => {
  const { autoclaves, bioboxesById, reload, unassignedTestResults, setOpenAssignBioboxModal, setOpenSporetestModal } = props

  const bioboxes = Array.from(bioboxesById.values())
  const unassignedMesaBoxIds = bioboxes.filter((box) => box.box_type === 'mesa' && box.autoclave_id === null).map((box) => Number(box.box_id))

  const testResults = {
    unassigned: {
      mesa: unassignedTestResults.filter((test) => test.test_type === 'mesa' && test.test_date !== null && unassignedMesaBoxIds.includes(Number(test.box_id))),
      crosstex: unassignedTestResults.filter((test) => {
        return test.test_type === 'crosstex' && test.test_date !== null
          || test.test_type === 'mesa' && test.test_date !== null && !unassignedMesaBoxIds.includes(Number(test.box_id))
      })
    }
  }

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }} className="box-header b-b">
        <WarningIcon sx={{ color: theme.palette.warning.main }} fontSize="small" />
        <span className="m-l-8">Unassigned Spore Test Results</span>
      </Box>
      <Box sx={{ pl: 2, pr: 2, fontSize: '13px' }}>
        <p>
          Your test results are displaying in this category because either you have not entered in your autoclave information or because the
          information on the spore test envelope did not exactly match the information we have on file for your autoclaves. If you purchased your
          biological monitoring product after mm/dd/yyyy, your test results are showing here because you have not assigned your box to an autoclave.
          Please assign now.
        </p>
        <p>To add your autoclave to your OnTraq account, please click on the "Add Autoclave" button.</p>
        <p>
          To reassign your test result to an autoclave, please click the icon under the "Assign" column for each test result. Then, select the
          autoclave to which to assign the test result.
        </p>
        <p>
          To assign your biological monitoring box to an autoclave, click “Assign Box” and then select the autoclave to which to assign the box. If
          you have not yet added your autoclave, please do so not by clicking “Add Autoclave”.
        </p>
      </Box>
      {
        testResults.unassigned.mesa.length > 0 && (
          <UnassignedSporetestsWithBoxes
            bioboxesById={bioboxesById}
            unassignedTestResults={testResults.unassigned.mesa}
            setOpenAssignBioboxModal={setOpenAssignBioboxModal}
            setOpenSporetestModal={setOpenSporetestModal}
          />
        )
      }
      {
        testResults.unassigned.crosstex.length > 0 && (
          <UnassignedSporetestsWithoutBoxes
            autoclaves={autoclaves}
            reload={reload}
            unassignedTestResults={testResults.unassigned.crosstex}
            setOpenSporetestModal={setOpenSporetestModal}
          />
        )
      }
    </Card>
  )
}

export default UnassignedSporetests;